export default __webpack_public_path__ + "2e90fbec05fb88941c0d8f61d6b9b0f0.png";